import { Box } from '@material-ui/core';
import { formatDateTimeReadable, getMerchantStructureByMerchantId, PayoutSummary } from '@nemuru-eng/js-api-client';

import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { Font } from '@/components/shared/components/Font';
import { LenderLogo } from '@/components/shared/components/Logo/LenderLogo/LenderLogo';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { Text } from '@/components/shared/components/Text';
import { useCache } from '@/hooks/requests/useCache';

interface LenderSummaryDetailsProps {
  payoutSummary: PayoutSummary;
}

export const LenderSummaryDetails = ({ payoutSummary }: LenderSummaryDetailsProps) => {
  const { data: merchantStructure } = useCache(getMerchantStructureByMerchantId, {
    merchantId: payoutSummary.merchantId,
  });

  if (!merchantStructure) return null;

  const merchantName = merchantStructure.merchant.businessName;

  return (
    <CustomPaper fill="paper">
      <Box display="flex" flexDirection="column" alignItems="flex-start" gridGap={8} pb={2}>
        <Font variant="overline" color="textSecondary">
          <Text tId={'LENDER'} />
        </Font>
        <LenderLogo lenderName={payoutSummary.lender} />
      </Box>
      <Box pb={2}>
        <ReadOnlyDataRow labelTextId={'LENDER_NAME'} value={payoutSummary.lender} underlined boxProps={{ py: 0 }} />
        <ReadOnlyDataRow
          labelTextId={'PAYOUT_REFERENCE'}
          value={payoutSummary.reference}
          underlined
          forceSingleLine
          copyButton
          boxProps={{ py: 0 }}
        />
        <ReadOnlyDataRow
          labelTextId={'ISSUE_DATE'}
          value={payoutSummary.issueDate ? formatDateTimeReadable(payoutSummary.issueDate) : '-'}
          underlined
          boxProps={{ py: 0 }}
        />
        <ReadOnlyDataRow
          labelTextId={'PAYOUT_DATE'}
          value={payoutSummary.payoutDate ? formatDateTimeReadable(payoutSummary.payoutDate) : '-'}
          underlined
          boxProps={{ py: 0 }}
        />
        <ReadOnlyDataRow labelTextId={'MERCHANT_NAME'} value={merchantName} underlined boxProps={{ py: 0 }} />
        <ReadOnlyDataRow
          labelTextId={'STATUS'}
          value={<Text tId={payoutSummary.status} />}
          underlined
          boxProps={{ py: 0 }}
        />
      </Box>
    </CustomPaper>
  );
};
